import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Button,
  CircularProgress,
  Avatar,
  Tooltip,
  Chip
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import { API_BASE } from "../config";


/* =====================================================
   🌍 DİL METİNLERİ
===================================================== */
const T = {
  tr: {
    title: "Muhasebe, Sigorta & Finans",
    requestTitle: "Kullanıcıdan Belge İste",
    selectUser: "Kullanıcı seç",
    customDoc: "İstenen belge (örn: Ek gelir belgesi)",
    createRequest: "Belge Talebi Oluştur",
    requestFromList: "Talep Oluştur",
  },
  de: {
    title: "Buchhaltung, Versicherung & Finanzen",
    requestTitle: "Dokument vom Benutzer anfordern",
    selectUser: "Benutzer auswählen",
    customDoc: "Gewünschtes Dokument",
    createRequest: "Dokument anfordern",
    requestFromList: "Anfordern",
  },
  en: {
    title: "Accounting, Insurance & Finance",
    requestTitle: "Request document from user",
    selectUser: "Select user",
    customDoc: "Requested document",
    createRequest: "Create request",
    requestFromList: "Request",
  },
};

/* =====================================================
   📋 CHECKLIST – GLOBAL / İSVİÇRE / GENİŞLETİLEBİLİR
===================================================== */
const CHECKLIST = [
  {
    id: "tax",
    title: { tr: "Vergi / Muhasebe", de: "Steuern / Buchhaltung", en: "Tax / Accounting" },
    items: [
      { tr: "Son Vergi Beyanı", de: "Letzte Steuererklärung", en: "Last tax return" },
      { tr: "Maaş Bordroları", de: "Lohnausweise", en: "Salary slips" },
      { tr: "Banka Dökümleri", de: "Bankauszüge", en: "Bank statements" },
      { tr: "Hayat Sigortası Poliçeleri", de: "Lebensversicherung", en: "Life insurance" },
    ],
  },
  {
    id: "insurance",
    title: { tr: "Sigorta", de: "Versicherungen", en: "Insurance" },
    items: [
      { tr: "Sağlık Sigortası", de: "Krankenkasse", en: "Health insurance" },
      { tr: "Araç Sigortası", de: "Autoversicherung", en: "Car insurance" },
      { tr: "Konut Sigortası", de: "Hausratversicherung", en: "Home insurance" },
    ],
  },
  {
    id: "finance",
    title: { tr: "Finans", de: "Finanzen", en: "Finance" },
    items: [
      { tr: "Kredi Belgeleri", de: "Kreditunterlagen", en: "Credit documents" },
      { tr: "Yatırım Belgeleri", de: "Investitionen", en: "Investments" },
      { tr: "Emeklilik / 3. Sütun", de: "Säule 3a", en: "Pension / Pillar 3a" },
    ],
  },
];

export default function MuhasebeBelgeler() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [customTitle, setCustomTitle] = useState("");
  const [requesting, setRequesting] = useState(false);
const [documents, setDocuments] = useState([]);
const [loadingDocs, setLoadingDocs] = useState(false);


  const token = localStorage.getItem("token");
  const lang = localStorage.getItem("lang") || "tr";
  const L = T[lang];


const updateStatus = async (docId, status) => {
  await fetch(`${API_BASE}/accounting/documents/${docId}/status`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ status }),
  });

  // tekrar yükle
  setDocuments((prev) =>
    prev.map((d) =>
      d.id === docId ? { ...d, status } : d
    )
  );
};


const handleDownload = async (doc, user) => {
  const url = `${API_BASE}/accounting/documents/${doc.id}/download`;

  const fileUrl = doc.files?.[0]?.file_url;
  if (!fileUrl) return;

  const extension = fileUrl.split(".").pop();

  const cleanUser =
    (user?.ad || user?.email || "kullanici")
      .replace(/\s+/g, "_")
      .replace(/[^\w]/g, "");

  const cleanTitle =
    (doc.title || "belge")
      .replace(/\s+/g, "_")
      .replace(/[^\w]/g, "");

  const date = new Date(doc.created_at)
    .toISOString()
    .split("T")[0];

  const fileName = `${cleanUser}-${cleanTitle}-${date}.${extension}`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    alert("İndirme başarısız");
    return;
  }

  const blob = await response.blob();
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};




const getFileExtension = (url) => {
  if (!url) return "";
  return url.split(".").pop().toLowerCase();
};

const formatFileSize = (size) => {
  if (!size) return "";
  if (size < 1024) return size + " B";
  if (size < 1024 * 1024)
    return (size / 1024).toFixed(1) + " KB";
  return (size / (1024 * 1024)).toFixed(1) + " MB";
};




  /* =====================================================
     👤 KULLANICILAR
  ===================================================== */
  useEffect(() => {
    fetch(`${API_BASE}/kullanicilar`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((d) => setUsers(d.data || []));
  }, [token]);

  /* =====================================================
     ➕ BELGE TALEBİ GÖNDER
  ===================================================== */
const createRequest = async (title) => {
  if (!selectedUser || !title) return;

  setRequesting(true);

  try {
    await fetch(`${API_BASE}/accounting/documents`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        user_id: selectedUser,
        title,
      }),
    });

    // Listeyi yeniden çek
    const res = await fetch(
      `${API_BASE}/accounting/documents`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const json = await res.json();
    setDocuments(json.data || []);

    setCustomTitle("");
  } catch (err) {
    console.error("Create request error:", err);
  }

  setRequesting(false);
};



useEffect(() => {
  const loadDocs = async () => {
    setLoadingDocs(true);

    try {
      const res = await fetch(
        `${API_BASE}/accounting/documents`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const json = await res.json();
      setDocuments(json.data || []);
    } catch (err) {
      console.error("Document load error:", err);
      setDocuments([]);
    }

    setLoadingDocs(false);
  };

  loadDocs();
}, [token]);


  /* =====================================================
     🧾 UI
  ===================================================== */
  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h4" fontWeight={700} mb={3} color="#0d6efd">
        📁 {L.title}
      </Typography>

      {/* =========================
          🧑‍💼 MANUEL TALEP
      ========================= */}
      <Box sx={{ mb: 4, p: 3, borderRadius: 2, background: "#f8f9fa", border: "1px solid #dee2e6" }}>
        <Typography fontWeight={700} mb={2}>
          ➕ {L.requestTitle}
        </Typography>

        <Stack spacing={2}>
          <select
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
            style={{ padding: 12, borderRadius: 8 }}
          >
            <option value="">{L.selectUser}</option>
            {users.map((u) => (
              <option key={u.id} value={u.id}>
                {u.ad || u.email}
              </option>
            ))}
          </select>

          <input
            placeholder={L.customDoc}
            value={customTitle}
            onChange={(e) => setCustomTitle(e.target.value)}
            style={{ padding: 12, borderRadius: 8 }}
          />

          <Button
            variant="contained"
            disabled={requesting}
            onClick={() => createRequest(customTitle)}
          >
            {L.createRequest}
          </Button>
        </Stack>
      </Box>

      {/* =========================
          📋 CHECKLIST → TEK TIK TALEP
      ========================= */}
      {CHECKLIST.map((section) => (
        <Accordion key={section.id} sx={{ mb: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight={600}>{section.title[lang]}</Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Stack spacing={1.5}>
              {section.items.map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography>{item[lang]}</Typography>

                  <Button
                    size="small"
                    variant="outlined"
                    disabled={!selectedUser}
                    onClick={() => createRequest(item[lang])}
                  >
                    {L.requestFromList}
                  </Button>
                </Box>
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      ))}
{/* =========================
    📂 KULLANICININ YÜKLEDİĞİ BELGELER
========================= */}
<Box sx={{ mt: 5 }}>
  <Typography variant="h6" fontWeight={700} mb={2}>
    {lang === "tr"
      ? "Kullanıcının Yüklediği Belgeler"
      : lang === "de"
      ? "Vom Benutzer hochgeladene Dokumente"
      : "Documents Uploaded by User"}
  </Typography>

  {loadingDocs ? (
    <CircularProgress />
  ) : documents.length === 0 ? (
    <Typography color="text.secondary">
      {lang === "tr"
        ? "Henüz belge yüklenmedi."
        : lang === "de"
        ? "Noch keine Dokumente hochgeladen."
        : "No documents uploaded yet."}
    </Typography>
  ) : (
    <Stack spacing={2}>
      {documents.map((doc) => {
        const user = users.find(
          (u) => String(u.id) === String(doc.kullanici_id)
        );
const fileUrl = doc.files?.[0]?.file_url;

        return (
          <Box
            key={doc.id}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: { xs: "column", md: "row" },
              gap: 2,
            }}
          >
            {/* SOL */}
           <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
  {/* DOSYA ICON / PREVIEW */}
  <Box>
{fileUrl && getFileExtension(fileUrl) === "pdf" && (
      <Avatar sx={{ bgcolor: "#e53935" }}>
        <PictureAsPdfIcon />
      </Avatar>
    )}

    {fileUrl &&
  ["jpg", "jpeg", "png", "webp"].includes(
    getFileExtension(fileUrl)
  ) && (

        <Avatar
src={`https://panel.haymestasarim.com${fileUrl}`}
          variant="rounded"
          sx={{ width: 56, height: 56 }}
        />
      )}

  {fileUrl &&
  !["jpg", "jpeg", "png", "webp", "pdf"].includes(
    getFileExtension(fileUrl)
  ) && (
        <Avatar sx={{ bgcolor: "#546e7a" }}>
          <InsertDriveFileIcon />
        </Avatar>
      )}
  </Box>

  {/* DOSYA BİLGİLERİ */}
  <Box>
    <Typography fontWeight={700}>
      {doc.title}
    </Typography>

{doc.files && doc.files.length > 0 && (
      <Stack direction="row" spacing={1} mt={0.5}>
        <Chip
          label={getFileExtension(doc.files[0]?.file_url
).toUpperCase()}
          size="small"
          color="default"
        />

        {doc.file_size && (
          <Chip
            label={formatFileSize(doc.file_size)}
            size="small"
            color="info"
          />
        )}
      </Stack>
    )}


              <Typography variant="body2" color="text.secondary">
                {lang === "tr"
                  ? `Kullanıcı: ${user?.ad || user?.email || "-"}`
                  : lang === "de"
                  ? `Benutzer: ${user?.ad || user?.email || "-"}`
                  : `User: ${user?.ad || user?.email || "-"}`}
              </Typography>

              <Typography variant="body2" color="text.secondary">
                {lang === "tr"
                  ? `Talep: ${new Date(doc.created_at).toLocaleString()}`
                  : lang === "de"
                  ? `Anfrage: ${new Date(doc.created_at).toLocaleString()}`
                  : `Requested: ${new Date(doc.created_at).toLocaleString()}`}
              </Typography>

              {doc.updated_at && (
                <Typography variant="body2" color="text.secondary">
                  {lang === "tr"
                    ? `Güncelleme: ${new Date(doc.updated_at).toLocaleString()}`
                    : lang === "de"
                    ? `Aktualisiert: ${new Date(doc.updated_at).toLocaleString()}`
                    : `Updated: ${new Date(doc.updated_at).toLocaleString()}`}
                </Typography>
              )}

              <Box mt={1}>
                <Chip
                  label={
                    doc.status === "approved"
                      ? lang === "tr"
                        ? "Geldi"
                        : lang === "de"
                        ? "Eingegangen"
                        : "Received"
                      : doc.status === "rejected"
                      ? lang === "tr"
                        ? "Gelmedi"
                        : lang === "de"
                        ? "Nicht eingegangen"
                        : "Not received"
                      : doc.status === "uploaded"
                      ? lang === "tr"
                        ? "Yüklendi"
                        : lang === "de"
                        ? "Hochgeladen"
                        : "Uploaded"
                      : lang === "tr"
                      ? "Bekleniyor"
                      : lang === "de"
                      ? "Ausstehend"
                      : "Pending"
                  }
                  color={
                    doc.status === "approved"
                      ? "success"
                      : doc.status === "rejected"
                      ? "error"
                      : doc.status === "uploaded"
                      ? "info"
                      : "warning"
                  }
                  size="small"
                />
              </Box>
            </Box>
</Box>
            {/* SAĞ */}
            <Stack direction="row" spacing={1}>



{fileUrl && (
                <Button
                  variant="contained"
                  color="primary"
           onClick={() => handleDownload(doc, user)}

                >
                  {lang === "tr"
                    ? "İndir"
                    : lang === "de"
                    ? "Herunterladen"
                    : "Download"}
                </Button>
              )}

              <Button
                variant="outlined"
                color="success"
                disabled={doc.status === "approved"}
                onClick={() => updateStatus(doc.id, "approved")}
              >
                {lang === "tr"
                  ? "Geldi"
                  : lang === "de"
                  ? "Eingegangen"
                  : "Received"}
              </Button>

              <Button
                variant="outlined"
                color="warning"
                disabled={doc.status === "rejected"}
                onClick={() => updateStatus(doc.id, "rejected")}
              >
                {lang === "tr"
                  ? "Gelmedi"
                  : lang === "de"
                  ? "Nicht eingegangen"
                  : "Not received"}
              </Button>
<Button
  variant="contained"
  sx={{
    backgroundColor: "#dc3545",
    "&:hover": { backgroundColor: "#bb2d3b" },
  }}
  onClick={async () => {
    if (!window.confirm("Bu belgeyi silmek istiyor musunuz?")) return;

    await fetch(`${API_BASE}/accounting/documents/${doc.id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setDocuments((prev) =>
      prev.filter((d) => d.id !== doc.id)
    );
  }}
>
  {lang === "tr"
    ? "Sil"
    : lang === "de"
    ? "Löschen"
    : "Delete"}
</Button>



            </Stack>
          </Box>
        );
      })}
    </Stack>
  )}
</Box>




      {requesting && (
        <Stack alignItems="center" mt={3}>
          <CircularProgress />
        </Stack>
      )}
    </Box>
  );
}
